var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubject1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_500_553)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8469 17.0333C26.0334 14.8468 26.0334 11.3017 23.8469 9.11516C21.6604 6.92863 18.1153 6.92863 15.9288 9.11516C13.7423 11.3017 13.7423 14.8468 15.9288 17.0333C18.1153 19.2198 21.6604 19.2198 23.8469 17.0333Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22.9434 10.0939L5.82925 16.3334C5.51898 16.4453 5.2421 16.6339 5.02443 16.8817C4.80676 17.1295 4.65539 17.4284 4.58444 17.7505C4.51594 18.0466 4.52351 18.3552 4.60645 18.6476C4.68939 18.94 4.84501 19.2066 5.0588 19.4226L8.56781 22.9316C9.05837 23.4221 9.81041 23.5805 10.4836 23.3345L12.9033 22.4528L12.0209 24.8717C11.8989 25.1965 11.872 25.5494 11.9434 25.889C12.0148 26.2285 12.1814 26.5407 12.4238 26.789L15.9328 30.298C16.3659 30.7311 16.9905 30.9079 17.6048 30.7724C17.9269 30.7014 18.2258 30.55 18.4736 30.3324C18.7214 30.1147 18.91 29.8378 19.0219 29.5276L25.2614 12.4134C25.5119 11.7298 25.3572 10.9962 24.8585 10.4975C24.3599 9.99889 23.6262 9.84421 22.9434 10.0939ZM23.7949 11.8779L17.5554 28.9921C17.532 29.0548 17.4935 29.1107 17.4434 29.1552C17.3934 29.1996 17.3332 29.2311 17.2682 29.2469C17.2019 29.2617 17.1083 29.2639 17.0384 29.1939L13.5293 25.6849C13.4653 25.6208 13.4498 25.5155 13.4888 25.4087L14.7535 21.9387C14.7874 21.8453 14.8077 21.7476 14.8139 21.6485L17.4928 18.9696C17.6393 18.8231 17.7216 18.6243 17.7216 18.4171C17.7216 18.2099 17.6393 18.0112 17.4928 17.8647C17.3463 17.7182 17.1476 17.6359 16.9404 17.6359C16.7332 17.6359 16.5345 17.7182 16.388 17.8647L13.7091 20.5436C13.6098 20.55 13.5119 20.5701 13.4181 20.6033L9.94814 21.868C9.84134 21.907 9.73601 21.8915 9.67193 21.8275L6.16291 18.3184C6.0922 18.2477 6.09515 18.1549 6.10988 18.0886C6.12662 18.0149 6.16361 17.9473 6.21668 17.8934C6.25277 17.8573 6.30139 17.8249 6.364 17.8006L23.4782 11.5612C23.6211 11.5096 23.7073 11.5545 23.7544 11.6017C23.8015 11.6488 23.8465 11.735 23.7949 11.8779Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_500_553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 17.6777) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubject1);
export default __webpack_public_path__ + "static/media/subject1.0d9723eb8287c9b4bf80fb4f51a4aba0.svg";
export { ForwardRef as ReactComponent };